import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

import scan from "../../assets/module-2/2-1-2-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_2 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.1.2 Neuroanatomy: Identifying Regions of Interest
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col text-center">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="text-center">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                      reserved.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="Sagittal MRI brain scan showing a side view of the brain, highlighting structures like the cerebrum, cerebellum, and brainstem with a green horizontal line across the image. Axial MRI scan of the brain with labeled regions, including the frontal lobe, fornix, temporal lobe, vermis of cerebellum, occipital lobe, and other structures. Each region is outlined and labeled with different colors."
                  style={{ maxWidth: "938px" }}
                />
              </FigureCaption>
            </div>
          </section>

          <section>
            <p>
              Moving superiorly, 3 of the 4 lobes of the cerebral cortex are
              encountered; the frontal lobe located at the front of the brain,
              the temporal lobe laterally, and the occipital lobe located at the
              back of the brain. The vermis of the cerebellum and fornix are
              also visible at this level.
            </p>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_2;
